import { createFileRoute } from "@tanstack/react-router";
import { NotBuiltYet } from "@/components/NotBuiltYet";

export const Route = createFileRoute("/catalog")({
  component: () => (
    <NotBuiltYet
      title="Service catalog"
      backlogId="BL-001"
      description="Browsable request types with approval chains. Approvals are their own authorization problem and need a threat review before they are built."
    />
  ),
});
